import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendar1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-1, date"} maskId="square-filled-radius-0-stroke-1-IconCalendar1"><path d="M7 4H3V9H21V4H17V2H16V4H8V2H7V4Z" fill="currentColor"/><path d="M3 21V10H21V21H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendar1;
